import { createSelector } from 'reselect'

import { LoginRootState } from '../loginRoot.reducer'

export const getUser = createSelector(
  (state: LoginRootState) => state.userStore.user,
  (state) => state,
)
export const getMessage = createSelector(
  (state: LoginRootState) => state.userStore.message,
  (state) => state,
)

export const getRedirectPath = createSelector(
  (state: LoginRootState) => state.userStore.redirectPath,
  (state) => state,
)
export const onError = createSelector(
  (state: LoginRootState) => state.userStore.error,
  (state) => state,
)
export const onSuccess = createSelector(
  (state: LoginRootState) => state.userStore.success,
  (state) => state,
)
export const isLogged = createSelector(
  (state: LoginRootState) => state.userStore.isLogged,
  (state) => state,
)
export const onFailedUserRegistration = createSelector(
  (state: LoginRootState) => state.userStore.onRegistration,
  (state) => state,
)
export const getCaptcha = createSelector(
  (state: LoginRootState) => state.userStore.captcha,
  (state) => state,
)

// Neuer Selector für den Erfolg der zweiten Registrierung
export const registrationFailedSuccess = createSelector(
  (state: LoginRootState) => state.userStore.failedRegistrationSuccess,
  (state) => state,
)
